import React, { memo, useEffect, useCallback, useState, useRef } from 'react';
import { func, string } from 'prop-types';
import Websocket from 'react-websocket';
import { noop } from '@ajaibid/utils';
import { useUserData } from '@services/users/me';

const { WEBSOCKET_ORDER_BOOK } = process.env;

const OrderBookSocket = ({ code, onMessage }) => {
  const wsRef = useRef();
  const { userData } = useUserData();
  const [isReady, setIsReady] = useState(false);

  const subscribe = useCallback(
    (_code) => {
      if (!isReady) return;
      wsRef.current.sendMessage(
        JSON.stringify({
          id: userData.id,
          method: 'SUBSCRIBE',
          stream: 'ORDER_BOOK',
          streamObject: encodeURI(_code),
          count: 20,
        })
      );
    },
    [isReady]
  );

  const unsubscribe = useCallback(
    (_code) => {
      if (!isReady) return;
      wsRef.current.sendMessage(
        JSON.stringify({
          id: userData.id,
          method: 'UNSUBSCRIBE',
          stream: 'ORDER_BOOK',
          streamObject: encodeURI(_code),
          count: 20,
        })
      );
    },
    [isReady]
  );

  const handleMessage = useCallback(
    (data) => {
      const parsedData = JSON.parse(data);
      onMessage(parsedData);
    },
    [onMessage]
  );

  useEffect(() => {
    subscribe(code);

    return () => {
      unsubscribe(code);
    };
  }, [subscribe, unsubscribe, code, isReady]);

  const handleOpen = useCallback(() => {
    setIsReady(true);
    subscribe(code);
  }, [subscribe]);

  if (userData && userData.id) {
    return (
      <Websocket
        url={WEBSOCKET_ORDER_BOOK}
        ref={wsRef}
        onOpen={handleOpen}
        onClose={() => {
          setIsReady(false);
        }}
        reconnect={false}
        debug={process.env.ENVIRONMENT === 'development'}
        onMessage={handleMessage}
      />
    );
  }

  return null;
};

OrderBookSocket.propTypes = {
  code: string,
  onMessage: func,
};

OrderBookSocket.defaultProps = {
  code: '',
  onMessage: noop,
};

export default memo(OrderBookSocket);
